import React, { Fragment, useEffect, useState, useContext } from "react"
import { UserContext } from "../../../../../../context/UserContext"
import { FlowHandlersContext } from "../../../../Menu/FlowContainer"
import { options } from "../util"
import { Stack, Typography } from "@mui/material"
import { FormContainer, NavButtons } from "../../../../Menu/Flow"
import CheckboxField from "../../../../../../components/CheckboxField"
import { TextField } from "../../../../../../legacyComponents/componentsV2/FlowV2/Fields"
import { RatingAreas } from "../components"
import { Styles } from "../../../../../../legacyComponents/config"
import employerFlowStyles from "../../styles"

const REQUIRED_EMPLOYMENT_GROUPS = ["FULL_TIME", "PART_TIME", "SEASONAL"]
const EMPLOYMENT_GROUP_MESSAGE = "Include at least one of Full-time, Part-time, or Seasonal employees."
const SINGLE_EMPLOYMENT_GROUP_MESSAGE = "Please select at least one employee group to proceed"

export default function Groups(props) {
    const { getEmployerPlan, getPermissibleClass } = useContext(UserContext)
    const flowHandlers = useContext(FlowHandlersContext)
    const { mode, exitUrl, step, formik, displayOnly, permissibleClassId } = props
    const { values, submitCount } = formik

    const permissibleClass = getPermissibleClass(permissibleClassId)
    const employerPlanId = permissibleClass?.employerPlanId
    const employerPlan = getEmployerPlan(employerPlanId)
    const planType = employerPlan?.type || ""
    // console.log("values = ",values)
    let header = "Employee Groups"
    // if (planType === "QSEHRA") {
    //     header = "Excluded Groups"
    // }
    let description = `Select which employee groups to include in or exclude from this class. (These employee groups are defined by IRS rules for ${planType} plan design.) `
    // if (planType === "QSEHRA") {
    //     description = "Select which employee groups to exclude from the QSEHRA. All employees are eligible and must be offered the QSEHRA unless they are in an excluded group."
    // }

    const [options1, setOptions1] = useState([])
    const [options2, setOptions2] = useState([])
    const [options3, setOptions3] = useState([])
    const [hasAttemptedSubmit, setHasAttemptedSubmit] = useState(false)

    const shouldShowErrors = hasAttemptedSubmit

    function getOptionOptions(planType) {
        let allOptions = null
        if (planType === "ICHRA") {
            allOptions = options.predefinedClasses["ICHRA"]
            // } else if (planType === "QSEHRA") {
            //     allOptions = options.predefinedClasses["QSEHRA"]
        } else if (planType === "EBHRA") {
            allOptions = options.predefinedClasses["EBHRA"]
        } else if (planType === "GCHRA") {
            allOptions = options.predefinedClasses["GCHRA"]
        }
        return allOptions
    }

    useEffect(() => {
        if (!planType) return
        const allOptions = getOptionOptions(planType)
        if (allOptions?.length > 0) {
            const hasWaiting = permissibleClass?.predefinedClasses.some(obj => obj.type === "WAITING");
            let lastWaiting = 9;
            if (hasWaiting) {
                lastWaiting = 10;
            }
            const option1 = allOptions.slice(0, 6)
            const option2 = allOptions.slice(6, lastWaiting)
            const option3 = allOptions.slice(10, 12)
            setOptions1(option1)
            setOptions2(option2)
            setOptions3(option3)
        } else {
            setOptions1([])
            setOptions2([])
            setOptions3([])
        }
    }, [])

    useEffect(() => {
        const allOptions = getOptionOptions(planType)
        if (!allOptions) return
        
        const hasWaiting = permissibleClass?.predefinedClasses.some(obj => obj.type === "WAITING");
        let lastWaiting = 9;
        if (hasWaiting) {
            lastWaiting = 10;
        }
        
        const option1 = allOptions.slice(0, 6)
        const option2 = allOptions.slice(6, lastWaiting)
        const employeeGroups = formik?.values?.predefinedClasses || {}

        // Handle options1 mutual exclusivity
        let finalOptions1 = option1.map((o) => ({ ...o, disabled: false }))

        // Handle FULL_TIME/PART_TIME/SEASONAL
        if (employeeGroups.FULL_TIME != null) {
            finalOptions1 = finalOptions1.map((o) =>
                ["PART_TIME", "SEASONAL"].includes(o.value)
                    ? { ...o, disabled: true }
                    : o
            )
        } else if (employeeGroups.PART_TIME != null) {
            finalOptions1 = finalOptions1.map((o) =>
                ["FULL_TIME", "SEASONAL"].includes(o.value)
                    ? { ...o, disabled: true }
                    : o
            )
        } else if (employeeGroups.SEASONAL != null) {
            finalOptions1 = finalOptions1.map((o) =>
                ["FULL_TIME", "PART_TIME"].includes(o.value)
                    ? { ...o, disabled: true }
                    : o
            )
        }

        // Handle SALARIED/NON_SALARIED
        if (employeeGroups.SALARIED != null) {
            finalOptions1 = finalOptions1.map((o) =>
                o.value === "NON_SALARIED" ? { ...o, disabled: true } : o
            )
        } else if (employeeGroups.NON_SALARIED != null) {
            finalOptions1 = finalOptions1.map((o) =>
                o.value === "SALARIED" ? { ...o, disabled: true } : o
            )
        }

        setOptions1(finalOptions1)

        // Handle options2 mutual exclusivity - only one can be selected at a time
        let finalOptions2 = option2.map((o) => ({ ...o, disabled: false }))
        
        // Find if any option2 item is selected
        const selectedOption2 = option2.find((o) => employeeGroups[o.value] != null)
        
        if (selectedOption2) {
            // Disable all other options in options2
            finalOptions2 = finalOptions2.map((o) =>
                o.value !== selectedOption2.value
                    ? { ...o, disabled: true }
                    : o
            )
        }

        setOptions2(finalOptions2)
    }, [formik.values, planType, options.predefinedClasses])

    useEffect(() => {
        if (!formik.values?.predefinedClasses?.RATING && Object.keys(formik?.values?.ratingAreas || {}).length != 0) {
            formik.setFieldValue('ratingAreas', {})
        }
    }, [formik.values])

    useEffect(() => {
        const employeeGroups = formik?.values?.predefinedClasses || {}
        const hasSelection = Object.keys(employeeGroups).length > 0
        const hasRequiredInclude = REQUIRED_EMPLOYMENT_GROUPS.some(
            (key) => employeeGroups[key] === true
        )
        const requireEmploymentGroup = planType !== "QSEHRA" && planType !== "EBHRA" && planType !== "GCHRA"
        const nextPredefinedClassesValue = hasSelection ? "yes" : ""
        if ((formik.values?.predefinedClasses_required || "") !== nextPredefinedClassesValue) {
            formik.setFieldValue("predefinedClasses_required", nextPredefinedClassesValue)
        }

        let nextGroupError = ""
        if (!hasSelection) {
            nextGroupError = SINGLE_EMPLOYMENT_GROUP_MESSAGE
        } else if (hasSelection && requireEmploymentGroup && !hasRequiredInclude) {
            nextGroupError = EMPLOYMENT_GROUP_MESSAGE
        }
        if ((formik.values?.group_error || "") !== nextGroupError) {
            formik.setFieldValue("group_error", nextGroupError)
        }
    }, [formik.values?.predefinedClasses, planType])

    function buildTouchedFromErrors(errors) {
        if (!errors || typeof errors !== "object") {
            return true
        }

        if (Array.isArray(errors)) {
            return errors.map((item) => buildTouchedFromErrors(item))
        }

        return Object.keys(errors).reduce((acc, key) => {
            acc[key] = buildTouchedFromErrors(errors[key])
            return acc
        }, {})
    }

    async function handleNext(event) {
        if (event) {
            event.preventDefault()
            event.stopPropagation()
        }

        setHasAttemptedSubmit(true)

        const errors = await formik.validateForm()
        const hasErrors = Object.keys(errors).length > 0
        const employeeGroups = formik.values?.predefinedClasses || {}
        const hasSelection = Object.keys(employeeGroups).length > 0
        const requireEmploymentGroup = planType !== "QSEHRA" && planType !== "EBHRA" && planType !== "GCHRA"
        const hasRequiredInclude = REQUIRED_EMPLOYMENT_GROUPS.some(
            (key) => formik.values?.predefinedClasses?.[key] === true
        )
        const missingRequiredGroup = requireEmploymentGroup && hasSelection && !hasRequiredInclude
        const noSelection = !hasSelection

        if (noSelection) {
            if (!formik.values?.group_error) {
                formik.setFieldValue("group_error", SINGLE_EMPLOYMENT_GROUP_MESSAGE)
            }
        } else if (missingRequiredGroup) {
            if (!formik.values?.group_error) {
                formik.setFieldValue("group_error", EMPLOYMENT_GROUP_MESSAGE)
            }
        }

        if (hasErrors || missingRequiredGroup || noSelection) {
            formik.setTouched(buildTouchedFromErrors(errors), true)
            return false
        }

        await formik.submitForm()

        if (flowHandlers?.onNext) {
            await flowHandlers.onNext(formik.values)
        }

        return false
    }

    return (
        <Stack spacing="30px" height="100%">
            <FormContainer>
                <Typography variant="h2" sx={employerFlowStyles.h2}>{header}</Typography>
                    <Typography>
                        {description}
                    </Typography>

                <Stack spacing={2} sx={{ marginTop: "20px" }}>

                    {/* {planType === "QSEHRA" ? (
                        <CheckboxField
                            formik={formik}
                            planType={planType}
                            type="checkbox"
                            name="predefinedClasses"
                            options={options.predefinedClasses["QSEHRA"]}
                            displayKey="display"
                            valueKey="value"
                            noneKey="ALL_ELIGIBLE_EMPLOYEES"
                            disabled={displayOnly}
                            validation="boolean"
                            shouldShowErrors={shouldShowErrors}
                        />
                    ) : ( */}
                    <Fragment>
                        <Stack direction="row" spacing="10px" sx={{
                            width: "150px",
                            flexShrink: 0,
                            justifyContent: "flex-start",
                            alignContent: "center"
                        }}>
                            <Typography>Include</Typography>
                            <Fragment>
                                <Typography>|</Typography>
                                <Typography>Exclude</Typography>
                            </Fragment>
                        </Stack>
                        <CheckboxField
                            showHeading={false}
                            formik={formik}
                            planType={planType}
                            type="checkbox-pair"
                            name="predefinedClasses"
                            options={options1}
                            displayKey="display"
                            valueKey="value"
                            disabled={displayOnly}
                            validation="boolean"
                            showExclude={false}
                            shouldShowErrors={shouldShowErrors}
                        />
                        <CheckboxField
                            showHeading={false}
                            formik={formik}
                            planType={planType}
                            type="checkbox-pair"
                            name="predefinedClasses"
                            options={options2}
                            displayKey="display"
                            valueKey="value"
                            disabled={displayOnly}
                            showInclude={false}
                            shouldShowErrors={shouldShowErrors}
                        />
                        <CheckboxField
                            showHeading={false}
                            formik={formik}
                            planType={planType}
                            type="checkbox-pair"
                            name="predefinedClasses"
                            options={options3}
                            displayKey="display"
                            valueKey="value"
                            disabled={displayOnly}
                            shouldShowErrors={shouldShowErrors}
                        />
                        {shouldShowErrors && formik.values.group_error && (
                            <Typography sx={{
                                fontSize: "12px",
                                color: Styles.Color.danger
                            }}>{formik.values.group_error}</Typography>
                        )}
                    </Fragment>
                    {/* )}
                     */}

                    {(values?.predefinedClasses && 'RATING' in values?.predefinedClasses && values?.predefinedClasses.RATING) && (
                        <RatingAreas {...props} />
                    )}
                </Stack>
            </FormContainer>

            <NavButtons mode={mode} enableSave={true} exitUrl={exitUrl} step={step} onNextStep={handleNext} />
        </Stack>
    )
}
